var account = {
    update: function(requestUrl){
        if($("#phoneInput").length){ 
            var phoneInputUser = document.querySelector("#phoneInput");

            var dataCountry = $("#phoneInput").data("country")

            if(dataCountry){
                var intPhone = intlTelInput(phoneInputUser, {
                    initialCountry: dataCountry,
                    utilsScript: main.host + "dist/js/utils.js",
                    preferredCountries: ['pe', 'co', 'mx','ar', 'es', 'us'],
                    placeholderNumberType: "MOBILE",
                    separateDialCode: true
                });
            }else{
                var intPhone = intlTelInput(phoneInputUser, {
                    initialCountry: "pe",
                    utilsScript: main.host + "dist/js/utils.js",
                    preferredCountries: ['pe', 'co', 'mx','ar', 'es', 'us'],
                    placeholderNumberType: "MOBILE",
                    separateDialCode: true
                });
            }

            //var fullNumPhone = intPhone.getNumber();
            //var countryData = intPhone.getSelectedCountryData().iso2;
        }
        $("#form-acccout-update").validate({
            // Specify the validation rules
            rules: {
                email: {required: true},
                lastName: {required: true},
                countryId: {required: true},
                name: {required: true},
                phoneInput: {required: true},
                password: {required: true},
                rut: {required: true}
            },
            // Specify the validation error messages
            messages: {
                email: {required: ""},
                lastName: {required: ""},
                name: {required: ""},
                countryId: {required: ""},
                password: {required: ""},
                phoneInput: {required: "Ingrese su número"},
                rut: {required: ""},
            },
            errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
             },
            submitHandler: function (form) {
                var fullNumPhone = $('#form-acccout-update .selected-dial-code').text() + '-' + $('#phoneInput').val();
                $("#form-acccout-update").find(".btn-l-primary").addClass("block-btn-load");
                var formData = new FormData();
                var files = $('#uploadImg')[0].files[0];
                formData.append('file',files);
                formData.append('phone',fullNumPhone);
                $('#form-acccout-update input, #form-acccout-update select, #form-acccout-update hidden').each(
                    function(index){  
                        var input = $(this);
                        formData.append(input.attr('name'),input.val());
                    }
                );
                $.ajax({
                    url: main.getUri(requestUrl),
                    data: formData, 
                    type: 'POST',
                    contentType: false,
                    dataType: "json",
                    processData: false,
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        $("#form-acccout-update").find(".btn-l-primary").removeClass("block-btn-load");
                        if (data.success == true) {
                            if(data.data.redirect.enabled) {
                                location.href = data.data.redirect.url;
                            } else {
                                Swal.fire({
                                    type: 'success',
                                    title: 'Ok',
                                    text: 'Se guardo correctamente',
                                })
                            }
                        } else { 
                            $('#idMessageLogin').show().addClass('block-error').html(data.message);
                        }
                    },
                    error : function(xhr, status) {
                        
                    }
                })
                return false;
            }
        });
    },
    changePassword: function()
    {
        $("#form-change-password").validate({
            // Specify the validation rules
            rules: {
                oldPassword: {required: true},
                password: {required: true},
                rePassword: {required: true}
            },
            // Specify the validation error messages
            messages: {
                oldPassword: {required: ""},
                password: {required: ""},
                rePassword: {required: ""},
            },
            errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
             },
            submitHandler: function (form) {
                $("#form-change-password").find(".btn-l-primary").addClass("block-btn-load");
                var params = $('#form-change-password').serialize();
                $.ajax({
                    url: main.getUri('/account/change-password'),
                    data: params,
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        $("#form-change-password").find(".btn-l-primary").removeClass("block-btn-load");
                        if(data.success) {
                            Swal.fire({
                                type: 'success',
                                title: 'Ok',
                                text: data.message,
                              })
                              $('#changePassModal').modal('hide');
                        } else {
                            Swal.fire({
                                type: 'error',
                                title: 'Oops...',
                                text: data.message,
                              })
                        }
                    },
                    error : function(xhr, status) {
                        
                    }
                })
                return false;
            }
        });
    },
    changeEmail: function()
    {
        $("#form-change-email").validate({
            // Specify the validation rules
            rules: {
                email: {required: true},
                reEmail: {required: true},
                password: {required: true}
            },
            // Specify the validation error messages
            messages: {
                email: {required: ""},
                reEmail: {required: ""},
                password: {required: ""},
            },
            errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
             },
            submitHandler: function (form) {
                $("#form-change-email").find(".btn-l-primary").addClass("block-btn-load");
                var params = $('#form-change-email').serialize();
                $.ajax({
                    url: main.getUri('/account/change-email'),
                    data: params,
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        $("#form-change-email").find(".btn-l-primary").removeClass("block-btn-load");
                        if(data.success) {
                            Swal.fire({
                                type: 'success',
                                title: 'Ok',
                                text: data.message,
                              })
                              $('#changeEmailModal').modal('hide');
                        } else {
                            Swal.fire({
                                type: 'error',
                                title: 'Oops...',
                                text: data.message,
                              })
                        }
                    },
                    error : function(xhr, status) {
                        
                    }
                })
                return false;
            }
        });
    },
    validateCodeActivation: function() {
        $("#form-code-activation").validate({
           rules: {
               'code': {
                   required: true
               },
           },
           messages: {
               'code': {
                   required: "Por favor ingresa su Email"
               },
           },
           errorPlacement: function(error, element) {
             error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
           },
           submitHandler: function(form) {
                if(!auth.params.login) {
                    auth.showLoginContinue('sendCodeActivation')
                } else {
                    $("#form-code-activation button").addClass("btn-disable");
                    $("#form-code-activation button").attr("disabled", true);
                    $("#form-code-activation button").html('Cargando...');
                    account.sendCodeactivation();
                }
               return false;
           }
       })
       return false;
    },
    sendCodeactivation: function(){
        var params = $('#form-code-activation').serialize();
        $("#form-code-activation").find(".btn-l-primary").addClass("btn-disable");
        $.ajax({
            url: "/es/gift-card/code-activate-validate",
            data: params,
            type: 'POST',
            dataType: "json",
            beforeSend: function (xhr){  },
            success : function(data) {
                if(data.success) {
                    checkout.order(data.data);
                } else {
                    $("#form-code-activation button").removeClass("btn-disable");
                    $("#form-code-activation button").attr("disabled", false);
                    $("#form-code-activation button").html('Activar');
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: data.message,
                    })
                }
                $("#form-code-activation").find(".btn-l-primary").removeClass("btn-disable");
            }
        });
    },
    removeSubscription: function(id) {
        var answer = confirm("Esta seguro de eliminar su suscripción?");
        if (answer) {
            $.ajax({
                url: "/es/account/subscription-remove/"+id,
                data: {'id': id},
                type: 'POST',
                dataType: "json",
                beforeSend: function (xhr){  },
                success : function(data) {
                    if(data.success) {
                        Swal.fire({
                            type: 'success',
                            title: 'Correcto'
                        });
                        location.reload();
                    } else {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: data.message
                        })
                    }
                }
            });
        }
    },
    calendarSearch: function(){
        $('input[name="daterange"]').daterangepicker({
            locale: {
                format: 'DD/MM/YYYY',
                separator: " - ",
                applyLabel: "Aplicar",
                cancelLabel: "Cancelar",
                fromLabel: "DE",
                toLabel: "HASTA",
                customRangeLabel: "Custom",
                daysOfWeek: [
                    "Dom",
                    "Lun",
                    "Mar",
                    "Mie",
                    "Jue",
                    "Vie",
                    "Sáb"
                ],
                monthNames: [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Diciembre"
                ],
                firstDay: 1
            }
        });
    },
    showPayment: function(id) {
        $('#loginPayment').modal('show');
        $('#form-change-card').trigger("reset");
        $.ajax({
            url: "/es/account/get-card/"+id,
            data: {'id': id},
            type: 'POST',
            dataType: "json",
            beforeSend: function (xhr){  },
            success : function(data) {
                $('#idSpanCard').html(data.data.number);
                $('#idCardReference').val(data.data.id);
            }
        });
    },
    sendFormChangeCard: function() {
        $("#form-change-card").validate({
            rules: {
                'number': {
                    required: true
                },
                'month': {
                    required: true
                },
                'year': {
                    required: true
                },
                'cvc': {
                    required: true
                },
            },
            messages: {
                'number': {
                    required: "Por favor ingresa su Email"
                },
                'month': {
                    required: "Por favor ingresa su Email"
                },
                'year': {
                    required: "Por favor ingresa su Email"
                },
                'cvc': {
                    required: "Por favor ingresa su Email"
                },
            },
            errorPlacement: function(error, element) {
              error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
            },
            submitHandler: function(form) {
                $("#form-change-card").find(".btn-l-primary").addClass("btn-disable");
                $.ajax({
                    url: "/es/account/change-card/",
                    data: $('#form-change-card').serialize(),
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr){  },
                    success : function(data) {
                        $("#form-change-card").find(".btn-l-primary").removeClass("btn-disable");
                        if(data.success) {
                            Swal.fire({
                                type: 'success',
                                title: 'Actualizado correctamente'
                            });
                            $('#loginPayment').modal('hide');
                            location.reload();
                        } else {
                            Swal.fire({
                                type: 'error',
                                title: 'Ocurrio un error, vuelve a intentarlo en unos minutos.',
                                text: data.message
                            })
                        }
                        
                    }
                });
                return false;
            }
        })
    }
}
